<template>
  <div class="rtl">
    <m-form
        :title="title"
        :items="items"
        :cols="cols"
        :canSubmit="canSubmit"
        :canDelete="canDelete"
        :is-editing.sync="isEditing"
        :showListBtn="false"
        :show-list-export-btn="false"
        :show-navigation-btns="false"
        @click:row="setItem"
        @clearForm="clearForm"
        @submit="submit"
        @delete="deleteItem"
        ref="form"
    >
      <template #header-btns></template>
      <template #default>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field class="rounded-lg" label=" * نام" v-model="item.name" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6">
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-select v-bind="attrs" v-on="on" :menu-props="{ bottom: true, offsetY: true }"
                  class="rounded-lg"
                  label="* سیستم انبار"
                  v-model="item.warehouse_system"
                  :items="warehouseSystems"
                  :disabled="
                  (item.id != undefined && item.warehouse_system != '') || !hasFeature('PERMANENT_FINANCIAL_YEAR')
                "
                  :return-object="false"/>
              </template>
              ابرمالی سبحان امکان نگه داری موجودی کلا به روش ادواری و دائمی را دارد
              <br/>
              در روش دائمی شما میتوانید
              بهای تمام شده کالا فروش رفته را به صورت لحظه ای مشاهده کنید
              <br/>
              اما در روش ادواری تنها در پایان دوره مالی با بستن سال مالی بصورت خودکار محاسبه میشود
            </v-tooltip>
          </v-col>
          <v-col cols="12" md="6">
            <date label=" * شروع" v-model="item.start" :default="false" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12" md="6">
            <date label=" * پایان" v-model="item.end" :default="false" :disabled="!isEditing" />
          </v-col>
          <v-col cols="12">
            <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
          </v-col>
        </v-row>
      </template>

      <template #item.activate="{ item }">
        <v-tooltip v-if="!financialYear || financialYear.id != item.id" top color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="changeFinancialYear(item)" color="secondary" icon large v-bind="attrs" v-on="on">
              <v-icon>fa-power-off</v-icon>
            </v-btn>
          </template>
          فعال سازی
        </v-tooltip>

        <v-tooltip v-else top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="success" icon large v-bind="attrs" v-on="on">
              <v-icon>fa-check</v-icon>
            </v-btn>
          </template>
          سال مالی فعال
        </v-tooltip>
      </template>
    </m-form>
    <v-dialog
        v-model="changeFinancialYearDialog"
        width="auto"
    >
      <v-card class="pa-5 rounded-lg">
        <v-card-title :style="{ color: '#F1416C' }"> آیا اطمینان دارید؟ </v-card-title>
        <v-card-text> با تغییر سال مالی سایر تب های سامانه بسته می شوند، میخواهید ادامه دهید؟ </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn depressed color="error" @click="changeFinancialYearDialog = false">خیر</v-btn>
          <v-btn depressed title="تغییر سال مالی" color="success" @click="activeFinancialYear">بله</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="settingUpFinancialYearDialog"
        class="rounded-lg"
        persistent
        max-width="420"
    >
      <v-card class="rounded-lg">
        <v-card-title class="white--text success text-h5">
          <v-img class="ml-3" src="/img/icons/cong.svg" max-height="35" max-width="35"></v-img>
          تبریک !
        </v-card-title>
        <v-card-text class="pt-5">
          <span>
            شما برای اولین بار کسب و کار خود را راه اندازی  کردید
          </span>
          <br>
          <span style="font-weight: bold">
            برای شروع کار با سامانه اولین سال مالی خود را ثبت و فعال کنید
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              text
              @click="settingUpFinancialYearDialog = false"
          >
            متوجه شدم
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { MFormMixin } from "@/components/m-form";
import GetUserApi from "@/views/panel/user/getUserApi.js";
import CompanyMixin from "@/views/panel/company/mixin";

export default {
  mixins: [MFormMixin, GetUserApi, CompanyMixin],
  props: {},
  data() {
    let warehouseSystems = [
      {
        text: "دائمی",
        value: "d",
      },
      {
        text: "ادواری",
        value: "a",
      },
    ];
    return {
      baseUrl: "companies/financialYears",
      permissionBasename: "financialYear",
      items: [],
      next_year: null,
      changeFinancialYearDialog: false,
      settingUpFinancialYearDialog: false,
      warehouseSystems: warehouseSystems,
      cols: [
        {
          text: "نام",
          value: "name",
        },
        {
          text: "سیستم انبار",
          value: "warehouse_system",
          type: "select",
          items: warehouseSystems,
        },
        {
          text: "شروع",
          value: "start",
          type: "date",
        },
        {
          text: "پایان",
          value: "end",
          type: "date",
        },
        {
          text: "",
          value: "activate",
          sortable: false,
          filterable: false,
        },
      ],
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("سال مالی");
    },
    createUrl() {
      return `${this.baseUrl}/`;
    },
    updateUrl() {
      return this.item.id && `${this.baseUrl}/${this.item.id}/`;
    },
    deleteUrl() {
      return this.item.id && `${this.baseUrl}/${this.item.id}/`;
    },
  },
  mounted() {
    if (!this.hasFeature('PERMANENT_FINANCIAL_YEAR')){
      this.$refs.form.item.warehouse_system = 'a'
    }
    if (this.user.active_company && this.user.financialYears.length === 0){
      this.settingUpFinancialYearDialog = true
    }
    if (!this.hasFeature("PERMANENT_FINANCIAL_YEAR")) {
      this.item.warehouse_system = "a";
    }
  },
  methods: {
    getData() {
      this.getUser();
      this.getFinancialYears((data) => (this.items = data));
    },
    getSerialized() {
      this.item.company = this.company.id;
      return this.item;
    },
    activeFinancialYear() {
      this.request({
        url: this.endpoint("users/setActiveFinancialYear"),
        method: "post",
        data: {
          financial_year: this.next_year.id,
        },
        success: (data) => {
          this.tabEmit("change:activeFinancialYear");
          this.successNotify();
          window.location.reload();
        },
      });
    },
    changeFinancialYear(item) {
      this.next_year = item;
      this.changeFinancialYearDialog = true;
    },
  },
};
</script>
<style lang="scss">
.cursor-pointer {
  cursor: pointer !important;
}

</style>